<template>
  <sw-card variant="setting-card">
    <div slot="header" class="flex flex-wrap justify-between lg:flex-nowrap">
      <div>
        <h6 class="sw-section-title">
          {{ $t('settings.structure.title') }}
        </h6>
        <p
          class="mt-2 text-sm leading-snug text-gray-500"
          style="max-width: 680px"
        >
          {{ $t('settings.structure.description') }}
        </p>
      </div>
      <div class="mt-4 lg:mt-0 lg:ml-2">
      <!--FUNZIONE PER CREARE NUOVA STRUTTURA-->
        <sw-button size="lg" variant="primary-outline" @click="openStructureModal">
          <plus-icon class="w-6 h-6 mr-1 -ml-2" />
          {{ $t('settings.structure.add_new_structure') }}
        </sw-button>
      </div>
    </div>

    <sw-table-component
      ref="table"
      :show-filter="false"
      :data="fetchData"
      table-class="table"
      variant="gray"
    >
      <sw-table-column
        :sortable="true"
        :label="$t('settings.structure.name')"
        show="name"
      >
        <template slot-scope="row">
          <span>{{ $t('settings.structure.name') }}</span>
          <span class="mt-6">{{ row.name }}</span>
        </template>
      </sw-table-column>

<!--
      <sw-table-column
        :sortable="true"
        :filterable="true"
        :label="$t('settings.structure.compound_tax')"
      >
        <template slot-scope="row">
          <span>{{ $t('settings.structure.compound_tax') }}</span>
          <sw-badge
            :bg-color="
              $utils.getBadgeStatusColor(row.compound_tax ? 'YES' : 'NO')
                .bgColor
            "
            :color="
              $utils.getBadgeStatusColor(row.compound_tax ? 'YES' : 'NO').color
            "
          >
            {{ row.compound_tax ? 'Yes' : 'No'.replace('_', ' ') }}
          </sw-badge>
        </template>
      </sw-table-column>
-->
      <sw-table-column
        :sortable="true"
        :filterable="true"
        :label="$t('settings.structure.invoice_code')"
      > 
        <template slot-scope="row">
          <span>{{ $t('settings.structure.invoice_code') }}</span>
          {{ row.invoice_code }} 
        </template>
      </sw-table-column>

      <sw-table-column
        :sortable="false"
        :filterable="false"
        cell-class="action-dropdown"
      >
        <template slot-scope="row">
          <span>{{ $t('settings.structure.action') }}</span>
          <sw-dropdown>
            <dot-icon slot="activator" />

            <sw-dropdown-item @click="editStructure(row.id)">
              <pencil-icon class="h-5 mr-3 text-gray-600" />
              {{ $t('general.edit') }}
            </sw-dropdown-item>

            <sw-dropdown-item @click="removeStructure(row.id)">
              <trash-icon class="h-5 mr-3 text-gray-600" />
              {{ $t('general.delete') }}
            </sw-dropdown-item>
          </sw-dropdown>
        </template>
      </sw-table-column>
    </sw-table-component>
<!--
    <sw-divider class="my-8" />

    <div class="flex mt-2">
      <div class="relative w-12">
        <sw-switch
          v-model="formData.tax_per_item"
          class="absolute"
          style="top: -20px"
          @change="setTax"
        />
      </div>

      <div class="ml-4">
        <p class="p-0 mb-1 text-base leading-snug text-black box-title">
          {{ $t('settings.structure.tax_per_item') }}
        </p>

        <p
          class="p-0 m-0 text-xs leading-4 text-gray-500"
          style="max-width: 480px"
        >
          {{ $t('settings.structure.tax_setting_description') }}
        </p>
      </div>
    </div>
-->
  </sw-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { TrashIcon, PencilIcon, PlusIcon } from '@vue-hero-icons/solid'

export default {
  components: {
    TrashIcon,
    PencilIcon,
    PlusIcon,
  },

  data() {
    return {
      formData: {
        tax_per_item: false,
      },
      isRequestOnGoing: false,
    }
  },

  computed: {
    ...mapGetters('structure', ['structure', 'getStructuresById']),
  },

  mounted() {
    this.getStructureSetting()
  },

  methods: {
    ...mapActions('modal', ['openModal']),
    ...mapActions('structure', [
      'indexLoadData',
      'deleteStructure',
      'fetchStructure',
      'fetchStructures',
    ]),
    ...mapActions('company', ['fetchCompanySettings', 'updateCompanySettings']),

    async fetchData({ page, filter, sort }) {
      let data = {
        orderByField: sort.fieldName || 'created_at',
        orderBy: sort.order || 'desc',
        page,
      }

      let response = await this.fetchStructures(data)

      return {
        data: response.data.structures.data,
        pagination: {
          totalPages: response.data.structures.last_page,
          currentPage: page,
          count: response.data.structures.count,
        },
      }
    },
    //-DA VEDERE
    async getStructureSetting() {
      let response = await this.fetchCompanySettings(['tax_per_item'])
      if (response.data) {
        this.formData.tax_per_item = response.data.tax_per_item === 'YES'
      }
    },
    //-DA VEDERE
    async setStructure(val) {
      // let data = {
      //   settings: {
      //     tax_per_item: this.formData.tax_per_item ? 'YES' : 'NO',
      //   },
      // }
      let response = await this.updateCompanySettings(data)
      if (response.data) {
        window.toastr['success'](this.$t('general.setting_updated'))
      }
    },

    async removeStructure(id, index) {
      swal({
        title: this.$t('general.are_you_sure'),
        text: this.$t('settings.structure.confirm_delete'),
        icon: '/assets/icon/trash-solid.svg',
        buttons: true,
        dangerMode: true,
      }).then(async (value) => {
        if (value) {
          let response = await this.deleteStructure(id)
          if (response.data.success) {
            window.toastr['success'](
              this.$t('settings.structure.deleted_message')
            )
            this.$refs.table.refresh()
            return true
          }
          window.toastr['error'](this.$t('settings.structure.already_in_use'))
        }
      })
    },

    openStructureModal() {
      this.openModal({
        title: this.$t('settings.structure.add_structure'),
        componentName: 'StructureModal',
        refreshData: this.$refs.table.refresh,
      })
    },

    async editStructure(id) {
      let response = await this.fetchStructure(id)
      this.openModal({
        title: this.$t('settings.structure.edit_structure'),
        componentName: 'StructureModal',
        id: id,
        data: response.data.structure,
        refreshData: this.$refs.table.refresh,
      })
    },
  },
}
</script>
